module.exports = __webpack_public_path__ + "static/media/edssupport.66f588d5.png";